interface DocumentScriptsData {
    url: string;
    body: Element[];
    head: Element[];
}

const endsWithIndexHtmlRegex = /index.html$/;
const getBaseUrl = (data: DocumentScriptsData) =>
    data.url.replace(endsWithIndexHtmlRegex, '');

const createBaseElement = (target: Document, url: string) => {
    const base = target.createElement('base');
    base.href = url;
    target.head.appendChild(base);
};

const updateBaseElement = (base: HTMLBaseElement, url: string) => {
    base.href = url;
};

const createOrUpdateBase = (target: Document, data: DocumentScriptsData) => {
    const url = getBaseUrl(data);
    const existingBase = target.querySelector('base');
    if (existingBase) {
        return updateBaseElement(existingBase, url);
    }

    return createBaseElement(target, url);
};

const shallowDumbNodeClone = (document: Document, node: Element) => {
    const clonedNode = document.createElement(node.nodeName);

    const attributesArray = Array.prototype.slice.call(node.attributes);
    attributesArray.forEach(x => clonedNode.setAttribute(x.name, x.value));

    clonedNode.innerHTML = node.innerHTML;
    return clonedNode;
};

const cloneAndAppend = (
    document: Document,
    parentNode: Element,
    scriptNode: Element,
) => {
    const clonedScriptNode = shallowDumbNodeClone(document, scriptNode);
    parentNode.appendChild(clonedScriptNode);
};

const addClass =
    (className: string) =>
    <T extends Element>(node: T) => {
        node.classList.add(className);
        return node;
    };

const insertInto = (
    document: Document,
    parentNode: Element,
    nodesToInsert: Element[],
) => {
    nodesToInsert
        .map(addClass('dazn'))
        .forEach(node => cloneAndAppend(document, parentNode, node));
};

const insert = (document: Document, data: DocumentScriptsData) => {
    createOrUpdateBase(document, data);
    insertInto(document, document.body, data.body);
    insertInto(document, document.head, data.head);
};

export { insert };
